import React from 'react';
import { Modal, Button } from 'react-bootstrap';

export const ConfirmBox = ({ ...props }) => {
    return (
        <Modal show={props.showModel} onHide={() => props.closeModel('', '', null)}>
            <Modal.Header closeButton>
                <Modal.Title>{props.header}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{props.body} </Modal.Body>
            {!props.hideButtons && (
                <Modal.Footer>
                    <Button
                        className="btn btn-primary"
                        id="modalYes"
                        onClick={() => props.callBack()}
                        title={props.t('confirmBox.button.yes')}
                    >
                        <span>{props.t('confirmBox.button.yes')}</span>
                    </Button>
                    <Button
                        className="btn btn-secondary"
                        id="modalNo"
                        onClick={() => props.closeModel('', '', null)}
                        title={props.t('confirmBox.button.no')}
                    >
                        <span>{props.t('confirmBox.button.no')}</span>
                    </Button>
                </Modal.Footer>
            )}
        </Modal>
    );
};
